
import { Component, Vue, Prop,Watch } from 'vue-property-decorator';

@Component
export default class Rank extends Vue {
    @Prop({default:false})
    isShow:boolean

    type:number = 1;

    rankList:any = []
    @Watch('isShow')
    change(){
        if(this.isShow){
            this.type = 1;
            this.getList();
        }else{
            document.getElementsByClassName('rankList')[0].scrollTo(0,0)
        }
    }
    created(){
        
    }
    onChoose(type:number){
        this.type = type;
        document.getElementsByClassName('rankList')[0].scrollTo(0,0)
        this.getList();
    }
    getList(){
        this.ajax({
            url:'/api/donate/rank',
            method:'get',
            params:{
                type: this.type
            }
        }).then((res:any)=>{
            this.rankList = res.data;
            
        })
    }
    onClose(){
        this.$emit('close');
    }
}
